import { useSharedState } from "./useSharedState";
import { useUser } from "../context/UserContext";

/**
 * Hook to manage face tracking state for the current user.
 * State is persisted in localStorage and shared across components.
 */
export function useFaceTracking() {
  const user = useUser();
  const [faceTrackingEnabled, setFaceTrackingEnabled] = useSharedState(
    `faceTracking:${user?.uid}`,
    false
  );

  return {
    faceTrackingEnabled,
    setFaceTrackingEnabled,
  };
}
